export default __webpack_public_path__ + "static/media/metamask.05749400.svg";